module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/fraternity-mobile-02-668e7450d6075b9b7e4e1326e7e2234e.jpg";